import { useEffect, useState } from "react";
import "./newYear.css";

export default function NewYearOverlay() {
  const [show, setShow] = useState(false);

  /* ================== ADDITIONS (SAFE) ================== */
  const TEST_MODE = false; // 👉 set true to force show anytime
  const CURRENT_YEAR = new Date().getFullYear();

  const today = new Date();
  const isJanuary = today.getMonth() === 0; // Jan = 0
  const isValidDate = today.getDate() >= 1 && today.getDate() <= 5;
  /* ====================================================== */

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem(`newYear${CURRENT_YEAR}`);

    /* ---------- DATE + TEST MODE CHECK ---------- */
    if (
      TEST_MODE ||
      (isJanuary && isValidDate && !alreadyShown)
    ) {
      setShow(true);
      sessionStorage.setItem(`newYear${CURRENT_YEAR}`, "shown");

      setTimeout(() => {
        setShow(false);
      }, 4000); // 8 seconds
    }
  }, []);

  if (!show) return null;

  return (
    <div className="ny-overlay">
      <div className="ny-content">
        <h2>आपको और आपके पूरे परिवार को</h2>

        <h1>
          🎉 नववर्ष {CURRENT_YEAR} की हार्दिक शुभकामनाएं 🎉
        </h1>

        <p className="company">
          <strong>Sriyansh Computers</strong> <br />
          A Centre for Complete Computer Solutions
        </p>

        <p className="contact">
          🌐 www.sriyansh.com
          <br />
          📞 9450887365
        </p>
      </div>

      {/* fireworks */}
      <div className="firework f1"></div>
      <div className="firework f2"></div>
      <div className="firework f3"></div>
    </div>
  );
}
